<template>
  <div id="payment-methods">
    <!-- <div class="container is-fluid"> -->
    <div class="columns is-flex-direction-column">
      <b-loading v-model="isLoading" :is-full-page="false"></b-loading>
      <div class="column">
        <div class="addpayment">
          <div class="buttons" @click="onClickAddPymentMethod">
            <a
              class="button is-light is-rounded is-fullwidth add-payment-link"
              href="#"
              >+ 支払い方法を追加</a
            >
          </div>

          <div
            class="paymentinfomation"
            v-for="(item, index) in paymentMethods"
            :key="index"
          >
            <div class="card">
              <div class="card-content">
                <dl class="credit is-clearfix">
                  <dt class="credit__dt">カード種別</dt>
                  <dd class="credit__dd">{{ item.brand }}</dd>
                  <dt class="credit__dt">カード番号</dt>
                  <dd class="credit__dd">••••{{ item.last4 }}</dd>
                  <dt class="credit__dt">有効期限</dt>
                  <dd class="credit__dd">
                    {{ item.exp_month }}/{{ item.exp_year }}
                  </dd>
                </dl>
              </div>
              <footer class="card-footer">
                <a
                  class="card-footer-item credit__delete"
                  href="#"
                  @click="onClickDeletePaymentMethod(item.id)"
                  >削除</a
                >
                <a
                  href="#"
                  class="card-footer-item"
                  @click="onClickEditPaymentMethod(item.id)"
                  >編集</a
                >
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import PaymentMethodFormModal from '@/components/PaymentMethodFormModal';

export default {
  name: 'PaymentMethods',
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    paymentMethods() {
      return this.$store.getters['payment/paymentMethods'];
    }
  },
  async created() {
    try {
      await this.$store.dispatch('payment/loadCustomer', {
        userId: this.$store.state.auth.uid,
        email: this.$store.state.auth.email
      });
    } catch (err) {
      console.log(err);
    }

    this.isLoading = false;
  },
  methods: {
    onClickAddPymentMethod() {
      this.$buefy.modal.open({
        parent: this,
        component: PaymentMethodFormModal,
        hasModalCard: true,
        trapFocus: true
      });
    },
    onClickDeletePaymentMethod(cardId) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Payment method',
        message:
          'Are you sure you want to <b>delete</b> your payment method? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('payment/deletePaymentMethod', {
            userId: this.$store.state.auth.uid,
            cardId: cardId
          });
          this.$buefy.toast.open('Payment method deleted!');
        }
      });
      this.$router.push('/payment#');
    },
    onClickEditPaymentMethod(cardId) {
      console.log('edit', cardId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/payment-methods.scss';
</style>
